
<mat-menu #mobileMenu="matMenu">
    <button mat-menu-item (click)="navigate('introduction')">
        <mat-icon>add</mat-icon>
        <span>Ny klage</span>
    </button>
    
    <button mat-menu-item (click)="navigate('cases')">
        <mat-icon>dynamic_feed</mat-icon>
        <span>Mine saker</span>
    </button>
    
    <button mat-menu-item (click)="navigate('faq')">
        <mat-icon>help</mat-icon>
        <span>Hjelp</span>
    </button>

    <mat-divider *ngIf="loggedIn"></mat-divider>
    
    <button *ngIf="loggedIn" mat-menu-item disabled>
        <mat-icon>person</mat-icon>
        <span>{{user?.DisplayName}}</span>
    </button>
    
    <mat-divider *ngIf="loggedIn"></mat-divider>
    
    <button *ngIf="loggedIn" mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Logg ut</span>
    </button>

</mat-menu>


<mat-menu #menu="matMenu">
    <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Logg ut</span>
    </button>
</mat-menu>

<div class="mat-elevation-z2 outer-toolbar">

    <mat-toolbar color="primary" class="mat-elevation-z0" role="heading">

        <h1 class="click" (click)="navigate('/')">{{title}}</h1>
        <div class="flex-spacer"></div>

        <div class="flex-row flex-gap-10" *ngIf="!isMobile">

            <a mat-button routerLinkActive="active-element" [routerLink]="['introduction']">Ny klage</a>

            <a mat-button routerLinkActive="active-element" [routerLink]="['cases']">Mine saker</a>

            <div *ngIf="loggedIn" class="profile-menu-button" mat-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">

                <mat-icon>account_circle</mat-icon>

                <div class="flex-column">
                    <div>{{user?.DisplayName}}</div>
                </div>

            </div>
        </div>

        <a *ngIf="!isMobile" class="help-button" matTooltip="Hjelp" mat-button [routerLink]="['faq']">Hjelp</a>

        <button *ngIf="isMobile" [matMenuTriggerFor]="mobileMenu" mat-icon-button aria-label="Icon-button with menu icon">
            <mat-icon>menu</mat-icon>
        </button>

    </mat-toolbar>
</div>